import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";

export const CodePipelinesLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListCodePipelines') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':name'
                element={
                    allowedActions.includes('GetCodePipeline') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/code-pipelines'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
